import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { IncomeActions } from './income.actions';

@Injectable({
  providedIn: 'root'
})
export class IncomeEffects {
  sendIncomeEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendIncomeEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(IncomeActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
